module.exports = __webpack_public_path__ + "static/media/idanci.bc1ac402.png";